import React from 'react';
import ReportFrame from '../ReportFrame';

export default class PrepayLineItemsAR extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = { Type: 2 };
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Line Items AR'
          reportParams={reportParams}
          id='prepaylineitemsar'
          name='prepaylineitemsAR'
          title='Prepay Line Items AR'
          hiddenParameters={['Type']}
        />
      </div>
    );
  }
}
